var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDailyFirstDeposits40X40 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 26.001,
    viewBox: "0 0 30 26.001",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_FirstDeposite",
    "data-name": "ico FirstDeposite",
    transform: "translate(-285.236 -363.862)",
    fill: "#74276b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47444",
    "data-name": "Path 47444",
    d: "M300.235,382.995a8.321,8.321,0,0,0,.2-1.827c0-.188-.011-.376-.021-.564.291.021.6.021.913.031l.041,2.4C300.982,383.037,300.6,383.027,300.235,382.995Z",
    transform: "translate(-.073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47445",
    "data-name": "Path 47445",
    d: "M308.752,371.521V373.3a.389.389,0,0,0-.073.282c0,.084-.322.554-1.784,1a20.669,20.669,0,0,1-9.358.23,8.314,8.314,0,0,0-2.593-1.536L294.9,371.6a8.121,8.121,0,0,0,1.452.554,22.143,22.143,0,0,0,10.934-.052A8.431,8.431,0,0,0,308.752,371.521Z",
    transform: "translate(-.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47441",
    "data-name": "Path 47441",
    d: "M308.752,367.342a8.1,8.1,0,0,1-1.463.591,22.131,22.131,0,0,1-10.925.052,7.486,7.486,0,0,1-1.452-.563v2.416c.761.285,2.191.7,2.211.712a19.164,19.164,0,0,0,4.589.508,18.924,18.924,0,0,0,5.187-.658c1.463-.448,1.786-.915,1.786-1a.391.391,0,0,1,.068-.278Z",
    transform: "translate(-.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47395",
    "data-name": "Path 47395",
    d: "M306.884,364.522a18.7,18.7,0,0,0-5.187-.658,18.121,18.121,0,0,0-5.122.658c-1.422.434-1.733.861-1.739,1,0,0,.007,0,.007.014.034.149.438.611,1.887,1.031a18.375,18.375,0,0,0,4.967.611,18.918,18.918,0,0,0,5.187-.651c1.463-.441,1.793-.91,1.793-1S308.349,364.973,306.884,364.522Z",
    transform: "translate(-.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47396",
    "data-name": "Path 47396",
    d: "M315.365,388.185v-2.037a7.59,7.59,0,0,1-1.3.577,16.863,16.863,0,0,1-5.119.712,17.492,17.492,0,0,1-4.655-.584,7.656,7.656,0,0,1-1.544-.617l.031,1.968v.013c0,.1.273.557,1.581,1a15.512,15.512,0,0,0,4.7.644,15.225,15.225,0,0,0,4.717-.665c1.308-.448,1.593-.916,1.593-1.011Z",
    transform: "translate(-.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47446",
    "data-name": "Path 47446",
    d: "M308.731,375.436v1.786c-2.884.084-5.861.689-6.961,1.911H301.7c-.518,0-1.037-.021-1.525-.052a8.1,8.1,0,0,0-1.1-2.486c.871.094,1.743.136,2.614.147a20.227,20.227,0,0,0,5.591-.721A8.2,8.2,0,0,0,308.731,375.436Z",
    transform: "translate(-.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47398",
    "data-name": "Path 47398",
    d: "M314.019,382.961a17.051,17.051,0,0,1-5.065.692,16.775,16.775,0,0,1-4.915-.658,7.126,7.126,0,0,1-1.351-.57l.025,1.427,0,.57c.484.658,2.8,1.506,6.23,1.506a15.8,15.8,0,0,0,4.754-.652c1.336-.448,1.6-.916,1.63-1.005a1.572,1.572,0,0,0,.044-.223v-1.663A6.756,6.756,0,0,1,314.019,382.961Z",
    transform: "translate(-.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47399",
    "data-name": "Path 47399",
    d: "M313.729,379.339a15.976,15.976,0,0,0-4.771-.644h-.1a15.492,15.492,0,0,0-4.419.576c-1.284.394-1.723.842-1.78,1.025a.06.06,0,0,0-.006.027l.012.027c.037.142.4.6,1.736,1.032a17.621,17.621,0,0,0,9.279-.034c1.376-.448,1.686-.916,1.693-1.018v-.006C315.358,380.222,315.049,379.773,313.729,379.339Z",
    transform: "translate(-.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48546",
    "data-name": "Path 48546",
    d: "M299.2,379.744a7.051,7.051,0,1,0,.139,1.415A7.386,7.386,0,0,0,299.2,379.744Zm-5.123,5.978H291.9v-6.481h-1.971v-1.874h4.15Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDailyFirstDeposits40X40);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_daily_first_deposits_40x40.2ea87268472db5b9b11d10533d6acbfd.svg";